export default class UIHashBaseContainer {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _parent: any;
    constructor() {
        this._parent = null;
    }

    get parent() {
        return this._parent;
    }
    set parent(value) {
        this._parent = value;
    }
    get parentHashKey() {
        return this._parent.hashKey;
    }
    get parentDisplayName() {
        return this._parent.displayName;
    }
}
